import React, { FC } from 'react'
import { IonModal, IonHeader, IonFooter, IonContent } from '@ionic/react'
import i18n from 'i18next'
import './index.scss'

interface IProps {
  title?: string;
  content?: any;
  cssClass?: string;
  reject?: () => void;
  resolve?: () => void;
}

const ConfirmModal: FC<IProps> = (props: IProps) => {
  const {
    title,
    content,
    cssClass,
    reject,
    resolve,
  } = props
  return (
    <IonModal
      cssClass={`mkt-confirm-modal ${cssClass || ''}`}
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss
      onDidDismiss={reject}
    >
      {
        title &&
          <IonHeader className='modal-header'>
            <span>{title}</span>
          </IonHeader>
      }
      {
        content &&
          <IonContent>
            <div className='modal-content'>
              {content || ''}
            </div>
          </IonContent>
      }
      <IonFooter className='modal-footer'>
        <div data-cypid='mmgCancelBuyRedeem' className='btn cancel' onClick={reject}>
          <span>{i18n.t('mkt.common.cancel')}</span>
        </div>
        <div data-cypid='mmgConfirmBuyRedeem' className='btn confirm' onClick={resolve}>
          <span>{i18n.t('mkt.common.confirm')}</span>
        </div>
      </IonFooter>
    </IonModal>
  )
}

export default ConfirmModal
